<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25993 21.3884H6C5.05719 21.3884 4.58579 21.3884 4.29289 21.0955C4 20.8026 4 20.3312 4 19.3884V18.2764C4 17.7579 4 17.4987 4.13318 17.2672C4.26636 17.0356 4.46727 16.9188 4.8691 16.6851C7.51457 15.1464 11.2715 14.2803 13.7791 15.7759C13.9475 15.8764 14.0991 15.9977 14.2285 16.1431C14.7866 16.77 14.746 17.7161 14.1028 18.2775C13.9669 18.396 13.8222 18.486 13.6764 18.5172C13.7962 18.5033 13.911 18.4874 14.0206 18.4699C14.932 18.3245 15.697 17.8375 16.3974 17.3084L18.2046 15.9433C18.8417 15.462 19.7873 15.4619 20.4245 15.943C20.9982 16.3762 21.1736 17.0894 20.8109 17.6707C20.388 18.3487 19.7921 19.216 19.2199 19.7459C18.6469 20.2766 17.7939 20.7504 17.0975 21.0865C16.326 21.4589 15.4738 21.6734 14.6069 21.8138C12.8488 22.0983 11.0166 22.0549 9.27633 21.6964C8.29253 21.4937 7.27079 21.3884 6.25993 21.3884Z"
      fill="#194BFB"
      opacity="0.5"
    />
    <path
      d="M6.58643 2.58594C6.21965 2.95271 6.08252 3.45945 6.03125 4.24995C7.24959 4.2337 8.23419 3.24911 8.25044 2.03076C7.45994 2.08203 6.9532 2.21916 6.58643 2.58594Z"
      fill="#194BFB"
    />
    <path
      d="M17.414 2.5857C17.0472 2.21892 16.5405 2.08179 15.75 2.03052C15.7662 3.24886 16.7508 4.23346 17.9692 4.24971C17.9179 3.45921 17.7808 2.95247 17.414 2.5857Z"
      fill="#194BFB"
    />
    <path
      d="M17.414 9.41425C17.0472 9.78103 16.5405 9.91816 15.75 9.96943C15.7663 8.75108 16.7508 7.76649 17.9692 7.75024C17.9179 8.54074 17.7808 9.04748 17.414 9.41425Z"
      fill="#194BFB"
    />
    <path
      d="M6.58643 9.41425C6.9532 9.78103 7.45994 9.91816 8.25044 9.96943C8.23419 8.75109 7.24959 7.76649 6.03125 7.75024C6.08252 8.54074 6.21965 9.04748 6.58643 9.41425Z"
      fill="#194BFB"
    />
    <path
      clip-rule="evenodd"
      d="M6 5.75C8.07107 5.75 9.75 4.07107 9.75 2H14.25C14.25 4.07107 15.9289 5.75 18 5.75V6.25C15.9289 6.25 14.25 7.92893 14.25 10H9.75C9.75 7.92893 8.07107 6.25 6 6.25V5.75ZM12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z"
      fill="#194BFB"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpWhySatoshiIcon3',
}
</script>